import { AfterViewInit, Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToolsModule } from '@huge-monorepo/shared/tools';
import { MatDialog } from '@angular/material/dialog';
import { DialogService } from '@huge-monorepo/shared/services';
import { ToastrService } from 'ngx-toastr';
import { MaterialModule } from '@huge-monorepo/shared/modules';
import { SharedTeltonikaSingletonService } from '@huge-monorepo/shared/services';
import { IHIPTeltonikaService, ICustomerTeltonikaService } from '@huge-monorepo/shared/interfaces';
import { UserRightsService } from '@huge-monorepo/hip/services';
import { TeltonikaUpdateDeviceByVersionComponent } from '../modals/teltonika-update-device-by-version/teltonika-update-device-by-version.component';
@Component({
  selector: 'huge-monorepo-teltonika-admin',
  standalone: true,
  imports: [CommonModule, ToolsModule, MaterialModule],
  templateUrl: './teltonika-admin.component.html',
  styleUrl: './teltonika-admin.component.scss',
})
export class TeltonikaAdminComponent implements OnInit, AfterViewInit {
  teltonikaService = this.sharedTeltonikaService.getService();

  constructor(
    private dialog: MatDialog,
    private dialogService: DialogService,
    private toastr: ToastrService,
    private sharedTeltonikaService: SharedTeltonikaSingletonService<ICustomerTeltonikaService | IHIPTeltonikaService>,
    private userRightsService: UserRightsService
  ) { }

  list: {} = {
    Heading: 'Teltonika Administration Menu',
    Items: [],
  };

  ngOnInit() {
    if (this.userRightsService.HasAccess('Teltonika', ['Admin'])) {
      this.list['Items'].push(
        {
          Description: 'Update Default Connection Credentials',
          Icon: 'vpn_key',
          isImage: false,
          Link: '/Teltonika/Admin/UpdateDefaultConnectionCredentials',
        },
        {
          Description: 'Update Email for Action Required Notifications',
          Icon: 'email',
          isImage: false,
          Link: '/Teltonika/Admin/UpdateEmailActionRequiredNotifications',
        },
        {
          Description: 'Update Teltonika Device',
          Icon: 'phonelink_setup',
          isImage: false,
          Link: '/Teltonika/Admin/UpdateTeltonikaDevice',
        },
        {
          Description: 'Create Custom Teltonika Device',
          Icon: 'desktop_windows',
          isImage: false,
          Link: '/Teltonika/Admin/CreateCustomTeltonikaDevice',
          Params: { isTeltonikaCustomDevice: true },
        },
        {
          Description: 'Update Device by Version',
          Icon: 'upgrade',
          isImage: false,
          Link: '/Teltonika/Admin/UpdateDeviceByVersion',
        },
        {
          Description: 'Upload Firmware',
          Icon: 'upload',
          isImage: false,
          Link: '/Teltonika/Admin/UploadFirmware',
        }
      );
    }
  }

  ngAfterViewInit() { }

}
